// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{font-family:Microsoft JhengHei,微軟正黑體,PingFang TC,蘋方-繁,Heiti TC,黑體,sans-serif!important}", ""]);
// Exports
module.exports = exports;
